export default "__VITE_ASSET__d5faa7e0__"